export default {
  featuredExperiences: '하이라이트 체험들',
  searchAllExperiences: '모든 체험 검색',
  searchAll: '모두 검색',
  groupSize: '그룹 규모',
  eventSize: '이벤트 규모',
  upTo: '최대',
  whatWeDo: '우리가 할 일',
  hostedBy: '호스트',
  whatsIncluded: '포함 내역',
  avail: '가능 여부',
  whereWeAre: '장소',
  experienceCalendar: '체험 일정',
  experienceCancelled: '체험이 취소되었습니다',
  experienceStartingPrice: '{{price}} 부터',
  experienceTotalPrice: '합계 {{price}}',
  at: '시간',
  viewPrivateSessAvailability: '개인 세션 가능여부 보기',
  selectSession: '세션 선택',
  sessionsCount: '{{count}}개의 시간 — 시간 선택',
  select: '선택',
  slotLeft: '{{remainSlots}} 자리 남음',
  slotsLeft: '{{remainSlots}} 자리 남음',
  spotsLeft: '{{count}}개 남음',
  spotsLeftAriaLabel: '{{count}}자리 남음',
  book: '예약',
  bookExperience: '체험 예약',
  learnMore: '자세히 보기',
  apply: '신청하기',
  maxPartySize: '그룹당 최대 {{maxGroupSize}} 명',
  maxPartySizes: '그룹당 최대 {{maxGroupSize}}명',
  selectSessionValidation: '세션을 선택해 주세요',
  selectParticipantValidation: '참가자를 선택해 주세요',
  selectDateValidation: '날짜를 선택해 주세요',
  reminders: '알림',
  seeOtherDates: '다른 날짜 보기',
  location: '위치',
  about: '소개',
  allExperiences: '모든 경험',
  soldOut: '품절',
  reviews: '이용 후기',
  reviewPlural: '리뷰',
  reviewSingular: '리뷰',
  dateOfExperience: '체험 날짜',
  readLess: '짧게 보기',
  readMore: '자세히 보기',
  seeMore: '더 보기',
  details: '소개',
  durationHour: '시간',
  durationHours: '시간',
  durationMinutes: '분',
  theFollowingVideoDoesNotContainAnyAudio:
    '다음 비디오에는 오디오가 포함되어 있지 않습니다',
  by: '~에 의해',
  chooseATime: '{{title}} 시간 선택',
  amenities: '편의시설',
  ticketSalesOpenIn: '티켓 판매 시작까지',
  ticketSalesOpen: '티켓 판매 중',
  ticketSalesCloseIn: '티켓 판매 종료까지',
  ticketSalesClose: '티켓 판매 종료',
  ticketSalesClosed: '티켓 판매가 종료되었습니다',
  comingSoon: '곧 출시됩니다',
  inPartnershipWith: '파트너십',
  notFoundExperienceTitle: '이 체험은 더 이상 이용할 수 없습니다',
  notFoundExperienceSubtitle:
    '게시가 취소되었거나 링크가 더 이상 유효하지 않을 수 있습니다.',
  deadLinkRecoverySubtitle: '예약할 수 있는 다른 체험을 찾아보세요',
  viewAllExperiences: '모든 체험 보기',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p>하얏트 월드 계정에 로그인 후 FIND 체험 예약에 지출한 정규 요금 미화 1달러당 <strong>기본 포인트</strong> 5점 적립</p>',
      basePoints:
        '<p>하얏트 월드 계정에 로그인 후 FIND 체험 예약에 지출한 정규 요금 미화 1달러당 <strong>기본 포인트</strong> 10점 적립</p>',
      additionalBonusPoints:
        '<p>하얏트 월드 신용카드로 예약 시 결제한 정규 요금 미화 1달러당 <strong>보너스 포인트 4점 추가 적립</strong></p>',
      additionalBonusPointsTier:
        '<p>등급 상태에 따라 보너스 포인트 <strong>최대 30%까지 추가 적립</strong></p>',
      payWithPoints: '<p>체험 예약 시 <strong>포인트로 결제</strong></p>',
    },
  },
};
